import styled from 'styled-components/macro'
import { mq } from 'styles/mq'

export const Container = styled.div`
  display: grid;
  grid-template-columns: auto auto;
  justify-items: center;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 1.3rem;

  ${mq.medium} {
    display: flex;
    gap: 2.5rem;
  }

  svg {
    display: block;
  }

  span {
    display: block;
    margin-top: -0.4em;
    font-size: 1.4rem;
    color: rgba(255, 255, 255, 0.5);
    grid-column: 1 / 3;

    ${mq.medium} {
      width: 12rem;
    }
  }
`
